import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { STATUTS, isImmatriculation } from "@/lib/dossiers";
import RisqueBadge from "@/components/dossiers/RisqueBadge";
import DossierActions from "@/components/dossiers/DossierActions";
import { cn } from "@/lib/utils";

export const statutClass = {
    en_cours: "bg-primary/10 text-primary border-transparent",
    pret_pour_analyse: "bg-emerald-100 text-emerald-800 border-transparent",
    en_attente_documents: "bg-amber-100 text-amber-800 border-transparent",
    clos: "bg-muted text-muted-foreground border-transparent",
};

export default function DossierRow({ dossier: d, onRisqueChange, onRenamed, onDeleted }) {
    const navigate = useNavigate();
    const date = new Date(d.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
    const open = () => navigate(`/dossiers/${d.id}`);

    return (
        <li
            data-testid={`dossier-row-${d.id}`}
            role="link"
            tabIndex={0}
            onClick={open}
            onKeyDown={(e) => e.key === "Enter" && open()}
            className="px-5 py-4 flex items-center gap-5 hover:bg-accent/40 transition-colors cursor-pointer"
        >
            <div className="min-w-0 flex-1">
                <p data-testid={`dossier-link-${d.id}`} className="text-sm font-medium text-foreground truncate">
                    {d.entreprises?.nom_entreprise || d.nom_mission || "Entreprise sans nom"}
                </p>
                <p data-testid={`dossier-entreprise-${d.id}`} className="mt-0.5 text-xs text-muted-foreground truncate">
                    {d.nom_mission || "Mission"}
                    {isImmatriculation(d.entreprises?.siren) ? " · En cours d'immatriculation" : ` · SIREN ${d.entreprises?.siren}`}
                    {d.users_clients?.prenom_nom ? ` · Contact : ${d.users_clients.prenom_nom}` : ""}
                </p>
            </div>
            <RisqueBadge dossierId={d.id} value={d.niveau_risque} source={d.niveau_risque_source} onChange={(n, s) => onRisqueChange?.(d.id, n, s)} />
            <Badge className={cn("rounded-full font-medium shadow-sm", statutClass[d.statut_dossier] ?? statutClass.clos)}>
                {STATUTS[d.statut_dossier] ?? d.statut_dossier}
            </Badge>
            <span className="text-xs text-muted-foreground w-24 text-right">{date}</span>
            <DossierActions dossier={d} onRenamed={onRenamed} onDeleted={onDeleted} />
            <ChevronRight className="h-4 w-4 text-muted-foreground" strokeWidth={1.75} />
        </li>
    );
}
